// https://cloud.tencent.com/developer/article/2025875

// const event_secret="4479364202322693:8224457245119383";
const event_secret="4479364202322693:8224457245119383";
// 分割字符串
const [secretKey, secretIv] = event_secret.split(':');
const CryptoJS = require("crypto-js"); // 引用AES源码js
const key = CryptoJS.enc.Utf8.parse(secretKey); // 十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse(secretIv); // 十六位十六进制数作为密钥偏移量
// 解密方法
export function Decrypt (word) {
  if (!word) return "";
  if (typeof word !== "string") return word;
  const encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  const decrypt = CryptoJS.AES.decrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CTR,
    padding: CryptoJS.pad.Pkcs7,
  });
  const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  const str = decryptedStr.toString();
  let val = str;
  try {
    val = JSON.parse(str);
  } catch (error) {
    //
  }
  return val;
}
// 加密方法
export function Encrypt (word) {
  if (!word) return "";
  const str = typeof word === "string" ? word : JSON.stringify(word);
  const srcs = CryptoJS.enc.Utf8.parse(str);
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CTR,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString().toUpperCase();
}
